baseApp.service('ImageService', function () {
    return {
        getBase64: function (file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        isImage: function (file) {
            var type = '|' + this.getImageType(file) + '|';
            return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
        },
        getImageTextForSrc: function (image, type) {
            return "data:" + guessImageMime(image, type) + image;
        },
        getImageType: function (file) {
            return file.type.slice(file.type.lastIndexOf('/') + 1);
        },
        isTypeSupported: function (type) {
            return type === 'image/png' || type === 'image/jpeg' || type === 'image/gif';
        }}});

    function guessImageMime(image, type) {
        if(type){
            return "image/" + type +";base64,";
        }
        else if (image.charAt(0) == '/') {
            return "image/jpeg;base64,";
        } else if (image.charAt(0) == 'R') {
            return "image/gif;base64,";
        } else if (image.charAt(0) == 'i') {
            return "image/png;base64,";
        }
    }